import { useState } from 'react';
import { IoQrCodeSharp } from "react-icons/io5";
import QRCode from 'react-qr-code'

import { cme_kurs } from './Global/Kurs'
import { mainPresentation } from './Global/Presentation'

import KursButton from './KursButton'
import MandatoryStar from './MandatoryStar';


export const QRCodeGeneratorContainer = ({ isHidden = true }) => {


    const [qrCodeText, setQRCodeText] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');

    // generate QR code
    const generateQRCode = () => {

        var errorMessage = document.querySelector(".qr-error-message");

        var agreementCheckbox = document.querySelector('.qr-code-container #qr-code-agreement');

        // -- validation
        if (firstName === "") {
            errorMessage.innerHTML = "Bitte tragen Sie Ihren Vornamen ein.";
        }
        else if (lastName === "") {
            errorMessage.innerHTML = "Bitte tragen Sie Ihren Nachnamen ein.";
        }
        else if (email === "") {
            errorMessage.innerHTML = "Bitte tragen Sie eine gültige E-Mail ein.";
        }
        else if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
            // wrong email format
            errorMessage.innerHTML = "Ihre E-Mail hat kein gültiges Format.";
        }
        else if (!agreementCheckbox.checked) {
            // didnt check agreement
            errorMessage.innerHTML = "Bitte bestätigen Sie unsere Richtlinien."
        }
        else {

            // -- validation succesfull
            errorMessage.innerHTML = "";

            var kursURL = cme_kurs.QRCodeURL;
            var newQRCodeURL = encodeURI(kursURL + "?ad_lastname=" + lastName + "&ad_firstname=" + firstName + "&ad_email=" + email);

            console.log("Generierter Link: " + newQRCodeURL);

            setQRCodeText(newQRCodeURL);
            showQRCodeSection();

            //show qr-code
            const qrCodeElement = document.getElementById('qrCodeEl');
            qrCodeElement.style.display = 'block';

        }
    }


    // hide QR-Code on changing text-input fields
    function hideQRCode() {
        const qrCodeElement = document.getElementById('qrCodeEl');
        qrCodeElement.style.display = 'none';
    }

    function showQRCodeSection() {
        var qrcodesection = document.getElementById("qr-code-section");
        qrcodesection.style.display = "block";
    }

    //on change handlers
    function onChangeFirstName(e) {
        setFirstName(e.target.value);
        hideQRCode();
    }
    function onChangeLastName(e) {
        setLastName(e.target.value);
        hideQRCode();
    }
    function onChangeEmail(e) {
        setEmail(e.target.value);
        hideQRCode();
    }

    return (
        <div className="qr-code-container" hidden={isHidden}>

            <div className="page-section--weiss forms-container">
                <div className="page-section-padding form-input-container">

                    <div className="reiter-headline">{cme_kurs.QRCodeTitel}</div><br />
                    <div>{cme_kurs.QRCodeBeschreibung}</div><br />

                    <div>
                        <label>Vorname<sup className="mandatory-field">*</sup></label>
                        <input name="firstnameInput" type="text" placeholder="Ihr Vorname" onChange={onChangeFirstName} /><br />
                    </div>

                    <div>
                        <label>Nachname<sup className="mandatory-field">*</sup></label>
                        <input name="lastnameInput" type="text" placeholder="Ihr Nachname" onChange={onChangeLastName} /><br />
                    </div>

                    <div>
                        <label>E-Mail<sup className="mandatory-field">*</sup></label>
                        <input name="emailInput" type="text" placeholder="Ihre Email-Adresse" onChange={onChangeEmail} /><br />
                    </div>

                    <div className='forCheckbox' style={{ fontSize: "0.8em" }}>
                        <input id="qr-code-agreement" name="qr-code-agreement" type="checkbox" />
                        <label htmlFor="qr-code-agreement">
                            Hiermit stimme ich der Verarbeitung meiner personenbezogenen Daten (<button type="button" className="link-button" onClick={() => mainPresentation.goToDatenschutz()}><u>siehe Datenschutzerklärung</u></button>) zum Zwecke der Zertifikatsübermittlung zu.
                            Den Widerruf meiner Einwilligung und die Löschung meiner personenbezogenen Daten kann ich über <a href="mailto:cmekurs@cmeducation.de"><u>cmekurs@cmeducation.de</u></a> jederzeit veranlassen.<sup className="mandatory-field">*</sup><br />
                        </label>
                    </div>

                    <MandatoryStar />

                    <div>
                        <p className="qr-error-message" style={{ "color": "red" }}></p>
                    </div>

                    <KursButton buttonName="QR-Code generieren" btnIcon={<IoQrCodeSharp />} onClick={generateQRCode} />

                </div>

            </div>

            <div id="qr-code-section" className="page-section--hellgrau hidden">
                <div className="page-section-padding">
                    <div id="qr-placeholder">
                        <QRCode
                            id="qrCodeEl"
                            size={300}
                            value={qrCodeText}
                        />
                    </div>
                </div>
                <div className="page-section-padding">
                    <p><u>Ihr generierter Link:</u></p>
                    <p><a style={{ fontSize: "0.75rem" }} href={qrCodeText}>{qrCodeText}</a></p>
                    <p>Sie können diesen Link kopieren und unabhängig von dem generierten QR-Code verschicken.</p>
                </div>
            </div>



        </div>
    )
}

export default QRCodeGeneratorContainer